import apiService from "@/core/services/api/api.service";
import { HttpResponse } from "@/core/types/http.types";
import {
  IBalance,
  IBalanceRequest,
  IBalanceResponse,
} from "@/core/models/balance.model";
import {
  balanceHistoryTransformer,
  balanceResultTransformer,
} from "../../transformers/balance.transformer";
import { DEFAULT_BALANCE } from "../../constants";
import { balanceUrls } from "@/core/services/api/urls";
import { FilterInterface } from "@/core/models/main.model";

// action types
export const ADD_BALANCE = "addBalance";
export const GET_BALANCE_HISTORY = "getBalanceHistory";

// mutation types
export const SET_BALANCE = "setBalanceData";
export const SET_BALANCE_HISTORY = "setBalanceHistory";

const state: IBalance = DEFAULT_BALANCE;

const getters = {
  balanceComposition(state: IBalance) {
    return state.result.composition;
  },
  balanceProduct(state: IBalance) {
    return state.result.product;
  },
  balanceReformer(state: IBalance) {
    return state.result.reformer;
  },
  balanceRecuperator(state: IBalance) {
    return state.result.recuperator;
  },
  balanceResult(state: IBalance) {
    return state.result;
  },
  balanceHistory(state: IBalance) {
    return state.history;
  },
};

const actions = {
  async [ADD_BALANCE](context: any, payload: IBalanceRequest) {
    try {
      const response = await apiService.request({
        request: {
          url: balanceUrls.add,
          method: "POST",
          data: payload,
        },
      });

      const { data } = response;
      context.commit(SET_BALANCE, data.data);

      return response;
    } catch (error: any) {
      throw { ...error } as HttpResponse;
    }
  },
  async [GET_BALANCE_HISTORY](context: any, filterData?: FilterInterface) {
    try {
      const response = await apiService.request({
        request: {
          url: balanceUrls.history,
          method: "GET",
          data: filterData,
        },
      });

      const { data } = response;
      context.commit(SET_BALANCE_HISTORY, data?.data || []);

      return response;
    } catch (error: any) {
      throw { ...error } as HttpResponse;
    }
  },
};

const mutations = {
  [SET_BALANCE](state: IBalance, response: IBalanceResponse) {
    state.result = balanceResultTransformer(response);
  },
  [SET_BALANCE_HISTORY](state: IBalance, response: IBalanceResponse[]) {
    state.history = balanceHistoryTransformer(response);
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
